import common from "../../common";
import GelButton from "../gel/GelButton";
import GelHackToggleButton from "../gel/GelHackToggleButton";
import QuestionInput from "./QuestionInput";

export default class QuestionInputSelect extends QuestionInput {
    constructor(question, view) {
        super(question, view);

        this._buttons = [];
        this._spacing = 134;
        this._selected = null;

        this._buttonsContainer = null;
        this._fontSize = 0;

        this._tutorialHandStart = new PIXI.Point();
        this._tutorialHandAnchor = new PIXI.Point();
        this._tutorialHandEnd = new PIXI.Point();
    }

    init() {
        this.createOptionButtons(this._question.options);

        super.init();
    }

    selectOption(option) {
        option.toggle = true;
        this._selected = option;
        const value = this._selected.value;
        this._view.setAnswer(value);
    }

    deselectOption(option) {
        option.toggle = false;
        this._selected = null;
    }

    lock() {
        for (let i = 0; i < this._buttons.length; ++i) {
            const button = this._buttons[i];
            button.enabled = false;
        }
    }

    unlock() {
        for (let i = 0; i < this._buttons.length; ++i) {
            const button = this._buttons[i];
            button.enabled = true;
        }
    }

    setInteractive(value) {
        for (let i = 0; i < this._buttons.length; ++i) {
            const button = this._buttons[i];
            button.interactive = value;
        }
    }

    createOptionButtons(options) {
        this._buttonsContainer = new PIXI.Container();
        this.addChild(this._buttonsContainer);

        // minimum font size
        this._fontSize = this.calculateFontSize(options);

        for (let i = 0; i < options.length; ++i) {
            const button = this.createOptionButton(options[i]);
            button.index = i;
            button.position.set(this._spacing * i - (this._spacing * (options.length - 1)) * 0.5, 0);
            button.tabIndex = GelButton.TAB_INDEX_LEVEL_1 + i;
            button.signals.down.add(this.onOptionButtonDown, this);
            button.signals.up.add(this.onOptionButtonUp, this);
            button.signals.click.add(this.onOptionButtonClick, this);

            const buttonBack = new PIXI.Sprite(P3.assets.texture("ui_drop_in_answerbox"));
            buttonBack.anchor.set(0.5);
            buttonBack.position.set(button.x, button.y);
            this._buttonsContainer.addChildAt(buttonBack, 0);
            this._buttonsContainer.addChild(button);
            this._buttons.push(button);
        }
    }

    createOptionButton(value) {
        const a = P3.assets;

        const buttonStates = new P3.ButtonStates();
        buttonStates.normal = a.texture("ui_drop_in_area");
        buttonStates.normalAlt = a.texture("ui_drop_in_area_selected");
        buttonStates.over = a.texture("ui_drop_in_area_highlight");
        buttonStates.over = a.texture("ui_drop_in_area_selected");

        const button = !PIXI.utils.isMobile.any ?
            new GelHackToggleButton(buttonStates) :
            new P3.ToggleButton(buttonStates);

        button.value = value;
        button.animate = false;
        button.animateIcon = false;
        button.tint = common.config.debug && button.value === this._question.answer ? 0x00AA00 : 0xFFFFFF;

        button.overSoundName = "sfx_btn_rollover_00";
        button.clickSoundName = "sfx_btn_press_00";

        button.label = new PIXI.Text(button.value.toString(), {
            fontSize: this._fontSize, fontFamily: "Arial", fontWeight: "bold", fill: 0x0});
        button.label.position.set(0, 0);
        button.label.anchor.set(0.5, 0.5);
        button.label.resolution = 2;
        button.animation.addChild(button.label);
        return button;
    }

    initTutorial() {
        super.initTutorial();

        let button;
        for (let i = 0; i < this._buttons.length; ++i) {
            button = this._buttons[i];
            if (button.value === this._question.answer) break;
        }

        if (button) {
            this._tutorialHandStart = new PIXI.Point(button.x + 40, button.y + 120);
            this._tutorialHandAnchor = new PIXI.Point(button.x + 40, button.y + 40);
            this._tutorialHandEnd = new PIXI.Point(button.x, button.y);
        }
    }

    animateTutorial() {
        this._tutorialHandTweens.removeAll();

        const a = new P3.utils.TWEEN.Tween(this._tutorialHand, this._tutorialHandTweens)
            .delay(200)
            .onStart(() => {
                this._tutorialHand.position.set(this._tutorialHandStart.x, this._tutorialHandStart.y);
                this._tutorialHand.alpha = 0;
            });

        const b = new P3.utils.TWEEN.Tween(this._tutorialHand, this._tutorialHandTweens)
            .to({x: [this._tutorialHandAnchor.x, this._tutorialHandEnd.x], y: [this._tutorialHandAnchor.y, this._tutorialHandEnd.y], alpha: 1}, 640)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .interpolation(P3.utils.TWEEN.Interpolation.Bezier)
            .onStart(() => {
                this._tutorialHand.visible = true;
            })
            .onComplete(() => {
                this._tutorialHand.gotoAndPlay("tap");
            });

        const c = new P3.utils.TWEEN.Tween(this._tutorialHand, this._tutorialHandTweens)
            .to({alpha: 0}, 240)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .delay(800)
            .onComplete(() => {
                this._tutorialHand.visible = false;
                this.animateTutorial();
            });

        a.chain(b);
        b.chain(c);
        a.start();
    }

    onOptionButtonDown(button) {
        // override
    }

    onOptionButtonUp(button) {
        // override
    }

    onOptionButtonClick(button) {
     //   for (let i = 0; i < )
        this._selected && this.deselectOption(this._selected);
        this.selectOption(button);
    }
}